import styled from 'styled-components';

import FullScreenIcon from '../../Icons/FullScreen';

import { CommonPropsButtons } from '../styles';

export const StyledFullScreenIcon = styled(FullScreenIcon)`
  ${CommonPropsButtons}
`;

export const StyledPressedFullScreenIcon = styled(StyledFullScreenIcon)`
  color: ${({ theme }) => theme.palette.primary.main};
`;
